import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import "./View.scss";

// Services
import { ApiService } from "../../services";

// Context

// Components
import { IonBadge, IonCol, IonContent, IonGrid, IonNote, IonRow } from "@ionic/react";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import ArticleSkeleton from "./ArticleSkeleton";

// Icons
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import { TrixContent } from "../../components/TrixContent";
import { dateTime } from "../../utils/format";
import { useViewport } from "../../utils/useViewport";

export const View = (props: any) => {
  const [id, setId] = useState<string>("");

  useEffect(() => {
    const matches = props.location.pathname.match(/\/news\/(\d*)\/?/);

    if (matches && matches[1]) {
      setId(matches[1]);
    }
  }, [props.location.pathname]);

  const { data, isLoading } = useQuery({
    queryKey: ["news", id],
    queryFn: () => ApiService.get("news/" + id),
  });

  const { isMobile } = useViewport();

  React.useEffect(() => {
    ReactGA.event({
      category: "news",
      action: "view",
      label: t("instance") || "",
    });
  }, [id]);

  return (
    <BasicTemplate hideHeader={false} title={isLoading ? t("loading") : data.data.title} hideBackButton={false}>
      <IonContent className={"ion-padding no-padding-top"} fullscreen={true}>
        {isLoading && <ArticleSkeleton />}
        {!isLoading && (
          <>
            <IonGrid
              style={{
                "--ion-grid-padding": "0",
              }}
            >
              <IonRow>
                <IonCol size={"12"} sizeMd={"8"} offsetMd={"2"} sizeLg={"6"} offsetLg={"3"}>
                  {data.data?.thumbnail_desktop ? <img src={data.data["thumbnail_" + (isMobile ? "mobile" : "desktop")]} className={"news-view"} alt={data.data?.title} /> : ""}
                  <h1>{data.data?.title}</h1>
                  <IonBadge
                    style={{
                      border: "1px solid " + data.data?.category?.colour,
                      "--background": "#fff",
                      "--color": "#000",
                    }}
                  >
                    {data.data?.category?.name}
                  </IonBadge>
                  <IonNote className={"block"}>{dateTime(data.data?.publish_at)}</IonNote>

                  <div className={"ion-margin-top"}>
                    <TrixContent content={data.data?.body} />
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </>
        )}
      </IonContent>
    </BasicTemplate>
  );
};
